import React from 'react';
import { Table } from 'semantic-ui-react';

export default function ContractTableHeader(props) {
	return (
		<Table.Row>
			<Table.HeaderCell
				width={2}
				sorted={props.column === 'contractID' ? props.direction : null}
				onClick={() => props.handleSort('contractID')}
			>
				ID
			</Table.HeaderCell>
			<Table.HeaderCell
				width={2}
				sorted={props.column === 'payerID' ? props.direction : null}
				onClick={() => props.handleSort('payerID')}
			>
				PAYER
			</Table.HeaderCell>
			<Table.HeaderCell
				width={2}
				sorted={props.column === 'createdOn' ? props.direction : null}
				onClick={() => props.handleSort('createdOn')}
			>
				Creation Date
			</Table.HeaderCell>
			<Table.HeaderCell
				width={2}
				sorted={props.column === 'expiry' ? props.direction : null}
				onClick={() => props.handleSort('expiry')}
			>
				Expiry Date
			</Table.HeaderCell>
			<Table.HeaderCell
				width={3}
				sorted={props.column === 'memo' ? props.direction : null}
				onClick={() => props.handleSort('memo')}
			>
				Memo
			</Table.HeaderCell>
			{/* <Table.HeaderCell width={1} /> */}
		</Table.Row>
	);
}
